<template>
    <div class="deskManages-main">
        <HeaderMenus :menuTitle="$t('桌码管理')" :tabList="tabList" @clickCallback="switchTab" ref="headerMenus"></HeaderMenus>
        <div class="cont">
            <DeskNumSetting v-if="$refs.headerMenus && $refs.headerMenus.activeValue === '0'"></DeskNumSetting>
            <AreaSetting v-if="$refs.headerMenus && $refs.headerMenus.activeValue === '1'"></AreaSetting>
            <TypeSetting v-if="$refs.headerMenus && $refs.headerMenus.activeValue === '2'"></TypeSetting>
        </div>
    </div>
</template>

<script>
import HeaderMenus from "@/components/common/headerMenus";
import {submitResEnum} from "@/logic/buildStore";
import DeskNumSetting from "./deskNumSetting";
import AreaSetting from "./areaSetting";
import TypeSetting from "./typeSetting";
export default {
    name: "deskManage",
    components: {
        HeaderMenus, DeskNumSetting, AreaSetting, TypeSetting
    },
    data() {
       return {
           tabList: [
               {
                   key: '0',
                   value: this.$t('桌位管理'),
               },
               {
                   key: '1',
                   value: this.$t('区域管理'),
               },
               {
                   key: '2',
                   value: this.$t('桌位类型'),
               }
           ]
       }
    },
    methods: {
        switchTab(i) {
        },
        onSubmit() {
            return submitResEnum.success
        }
    },
    mounted() {
        this.$forceUpdate()
    }
}
</script>

<style scoped lang="scss">
.deskManages-main {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .cont {
        height: 100%;
        flex: auto;
        overflow-y: auto;
        margin-top: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/buildstore/services/deskManage/index.vue